import { useEffect } from 'react';

import { io } from 'socket.io-client';

import { BorrowerRole } from 'enums/BorrowerRole';
import { LoadingType, setLoadingState } from 'prequalificationV2/actions';
import { DashboardTabName } from 'enums/DashboardTabName';
import { getApplicationInfoForDashboardThunk } from 'prequalificationV2/thunks/getApplicationInfoForDashboard';
import { useAppDispatch } from 'prequalificationV2/hooks/useAppDispatch';

const useIncomeWaterfallSocket = (
  applicationId: string,
  borrowerType: BorrowerRole,
  borrowerId: string,
  token: string | null,
) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!applicationId || !borrowerId || !token) {
      return;
    }

    const socket = io(`${process.env.REACT_APP_WEBSOCKET_URL}/income-waterfall`, {
      query: { applicationId: applicationId },
      auth: {
        token: `Bearer ${token}`,
      },
    });

    const loadingType = `${LoadingType.RequiredInformationUpdating}${
      borrowerType === BorrowerRole.Borrower
        ? DashboardTabName.BorrowerInformation
        : DashboardTabName.CoBorrowerInformation
    }`;

    socket.on('waterfall:updated', async () => {
      dispatch(setLoadingState({ type: loadingType, loading: true }));

      try {
        await dispatch(getApplicationInfoForDashboardThunk(borrowerId)).unwrap();
      } finally {
        dispatch(setLoadingState({ type: loadingType, loading: false }));
      }
    });

    socket.on('connect_error', (error) => {
      console.error('Income waterfall socket connection error:', error);
    });

    return () => {
      socket.disconnect();
    };
  }, [applicationId, borrowerType, borrowerId, dispatch, token]);
};

export default useIncomeWaterfallSocket;
